import * as React from "react";
import { IAppointmentConfirmationProps } from "../Types";
import { renderAppointmentsList, renderConfirmationButtons } from "../SubComponents";

export const ValidOnlyAppointmentScenario = (props: IAppointmentConfirmationProps) => (
    <div>
        {renderAppointmentsList(props.appointments.validAppointments, false, props)}
        {renderConfirmationButtons(true, props, props.isLoadingSpinnerActive)}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/AppointmentConfirmation/Scenarios/ValidOnlyAppointmentScenario.tsx